import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalPage() {
  const navigate = useNavigate();

  return (
    <div className="py-6 space-y-6" data-testid="legal-page">
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 text-sm text-muted-foreground hover:text-[#FF6B35] transition-colors"
        data-testid="legal-back-btn"
      >
        <ArrowLeft className="w-4 h-4" />
        Retour
      </button>

      <div className="bg-card border border-border rounded-3xl p-6 shadow-sm space-y-6">
        <h1 className="font-heading font-bold text-2xl text-card-foreground">
          Conditions Generales d'Utilisation
        </h1>
        <p className="text-xs text-muted-foreground">Derniere mise a jour : Mars 2026</p>

        <section className="space-y-3">
          <h2 className="font-heading font-bold text-base text-card-foreground">1. Objet</h2>
          <p className="text-sm text-card-foreground/80 leading-relaxed">
            Les presentes Conditions Generales d'Utilisation (CGU) regissent l'acces et l'utilisation
            de la plateforme ReallyFan, un reseau social musical gamifie permettant aux fans de
            soutenir leurs artistes preferes via un systeme de credits et de mises.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-heading font-bold text-base text-card-foreground">2. Inscription et Compte</h2>
          <p className="text-sm text-card-foreground/80 leading-relaxed">
            L'inscription est gratuite et ouverte a toute personne physique agee de 15 ans minimum
            (conformement a l'article 7-1 de la loi Informatique et Libertes pour les mineurs).
            L'utilisateur s'engage a fournir des informations exactes et a maintenir la confidentialite
            de ses identifiants de connexion. Tout compte est personnel et non cessible.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-heading font-bold text-base text-card-foreground">3. Credits et Mises</h2>
          <p className="text-sm text-card-foreground/80 leading-relaxed">
            Les credits ReallyFan sont des droits d'usage internes a la plateforme. Ils ne constituent
            pas une monnaie et ne sont pas convertibles en argent reel. Les credits peuvent etre
            obtenus gratuitement (inscription, streak, parrainage) ou achetes via Stripe. Les mises
            sur les artistes sont definitives et non remboursables.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-heading font-bold text-base text-card-foreground">4. Recompenses</h2>
          <p className="text-sm text-card-foreground/80 leading-relaxed">
            Les recompenses proposees par les artistes sont echangeables contre des credits.
            L'echange est definitif. La livraison des recompenses (contenu digital, merch, etc.)
            est sous la responsabilite de l'artiste. ReallyFan n'est pas responsable des
            recompenses non honorees par les artistes.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-heading font-bold text-base text-card-foreground">5. Contenu Utilisateur</h2>
          <p className="text-sm text-card-foreground/80 leading-relaxed">
            Les utilisateurs sont responsables du contenu qu'ils publient. Tout contenu illegal,
            haineux, diffamatoire ou portant atteinte aux droits d'autrui est interdit et pourra
            entrainer la suspension ou la suppression du compte.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-heading font-bold text-base text-card-foreground">6. Propriete Intellectuelle</h2>
          <p className="text-sm text-card-foreground/80 leading-relaxed">
            La plateforme ReallyFan, son design, son code et ses fonctionnalites sont proteges
            par le droit de la propriete intellectuelle. Toute reproduction non autorisee est interdite.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-heading font-bold text-base text-card-foreground">7. Infrastructure Technique</h2>
          <p className="text-sm text-card-foreground/80 leading-relaxed">
            ReallyFan est developpe et heberge avec la technologie Emergent (emergent.sh).
            L'infrastructure technique est fournie par des services cloud tiers pour garantir
            la disponibilite et la securite de la plateforme.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-heading font-bold text-base text-card-foreground">8. Protection des Donnees</h2>
          <p className="text-sm text-card-foreground/80 leading-relaxed">
            Les donnees personnelles collectees sont traitees conformement au RGPD.
            L'utilisateur dispose d'un droit d'acces, de rectification, d'effacement
            et de portabilite de ses donnees. Consultez notre{" "}
            <a href="/privacy" className="text-[#FF6B35] hover:underline font-medium">Politique de Confidentialite</a>{" "}
            pour plus de details.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-heading font-bold text-base text-card-foreground">Mentions Legales</h2>
          <p className="text-sm text-card-foreground/80 leading-relaxed">
            <strong>Editeur :</strong> kila<br />
            <strong>Adresse :</strong> 1 A route de Bayon, 54290 Haigneville, France<br />
            <strong>Hebergement :</strong> Infrastructure cloud (Emergent / services tiers)<br />
            <strong>Contact :</strong> via la plateforme ReallyFan
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-heading font-bold text-base text-card-foreground">9. Limitation de Responsabilite</h2>
          <p className="text-sm text-card-foreground/80 leading-relaxed">
            ReallyFan est fourni "en l'etat". La plateforme ne garantit pas un service
            ininterrompu et ne saurait etre tenue responsable des pertes de credits dues
            a des dysfonctionnements techniques.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-heading font-bold text-base text-card-foreground">10. Modification des CGU</h2>
          <p className="text-sm text-card-foreground/80 leading-relaxed">
            ReallyFan se reserve le droit de modifier les presentes CGU a tout moment.
            Les utilisateurs seront informes des modifications via la plateforme.
            L'utilisation continue du service apres modification vaut acceptation.
          </p>
        </section>
      </div>
    </div>
  );
}
